import { useEffect } from 'react';
import { Container } from 'semantic-ui-react'
import NavBar from './NavBar';
import { observer } from 'mobx-react-lite';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import HomePage from '../../features/home/HomePage';
import {ToastContainer} from 'react-toastify';
import { useStore } from '../stores/store';
import LoadingComponent from './LoadingComponent';
import ModalContainer from '../common/modals/ModalContainer';
import Footer from './Footer';
import ReactGA from "react-ga4";
import { GTM_ID } from '../common/data/constants';

function App() {
    const location = useLocation();
    const { commonStore, userStore} = useStore();
    const {getUser} = userStore;

    useEffect(() => {
      if(commonStore.token) {
        getUser().finally(() => commonStore.setAppLoaded())
      } else {
        commonStore.setAppLoaded();
      }
    }, [commonStore, getUser])

    useEffect(() => {
      if (!ReactGA.isInitialized) {
        ReactGA.initialize(GTM_ID);
      }
  
      // Initialize google analytics page view tracking
      ReactGA.send({ hitType: "pageview", page: location });
    }, [location])

    if (!commonStore.appLoaded) return <LoadingComponent content='Loading app...' />

    return (
        <>
          <ScrollRestoration />
          <ModalContainer />
          <ToastContainer 
              position='bottom-center'
              closeOnClick
              newestOnTop
              theme='dark'
          />
          {location.pathname === '/' ? <HomePage /> : (
            <>
                <NavBar />
                <Container className="mt-[6em]">
                  <Outlet />
                  <Footer />
                </Container>
              </>
          )}
        </>
    );
}

export default observer(App);